import { Injectable, signal } from '@angular/core';

const PERSISTENCE_KEY_HINTS = ['grid', 'Grid', 'ejs-', 'dashboard'];

const RETIRED_WIDGET_CACHE_KEYS = [
  'griddashboardTestCasesWidget',
  'griddashboardExecutionsWidget',
  'griddashboardAiValidationsWidget',
  'griddashboardSchedulesWidget',
  'griddashboardNotificationsWidget',
];

@Injectable({ providedIn: 'root' })
export class PersistenceGateService {
  /** Full-screen loader while Clear Persistence is running. */
  readonly isResetting = signal(false);
  readonly resetVersion = signal(0);

  clearLocalPersistence(): void {
    this.removeMatchingKeys(localStorage);
    this.removeMatchingKeys(sessionStorage);
    this.resetVersion.update((version) => version + 1);
  }

  clearRetiredWidgetCache(): void {
    RETIRED_WIDGET_CACHE_KEYS.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  }

  private removeMatchingKeys(storage: Storage): void {
    const keysToRemove: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key && PERSISTENCE_KEY_HINTS.some((hint) => key.includes(hint))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => storage.removeItem(key));
  }
}
